import React, { useState } from "react";
import { Link } from "react-router-dom";
import Herosec from "../Components/Herosec-copy";
import { ImCross } from "react-icons/im";
import { FaCheckCircle } from "react-icons/fa";
import { FaServer, FaHandPointer, FaSync, FaDesktop, FaHdd, FaLock } from 'react-icons/fa';
import CurrencyConverter from "../Components/CurrencyConverter";
import { useGeoLocation } from "../utils/useGeoLocation";
import EnhancedSEO from "../Components/EnhancedSEO";
import { 
  generateMetaTags, 
  pageConfigs, 
  organizationSchema, 
  generateServiceSchema,
  generateFAQSchema
} from "../utils/seoUtils";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import Divider from "../Components/Divider";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const FeatureCard = ({ icon, title, children }) => {
  const [isHovered, setIsHovered] = useState(false);

  const cardStyle = {
    backgroundColor: isHovered ? '#f8f9fa' : '#fff',
    borderRadius: '10px',
    padding: '30px 25px',
    height: '100%',
    boxShadow: isHovered ? '0 8px 25px rgba(0,0,0,0.1)' : '0 5px 15px rgba(0,0,0,0.05)',
    transition: 'all 0.3s ease',
    border: '1px solid',
    borderColor: isHovered ? '#21A2A0' : '#e9ecef',
    cursor: 'pointer',
    transform: isHovered ? 'translateY(-5px)' : 'translateY(0)'
  };

  const iconStyle = {
    width: '70px',
    height: '70px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px',
    backgroundColor: 'rgba(33, 162, 160, 0.1)',
    color: '#21A2A0',
    fontSize: '28px'
  };

  const titleStyle = {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '-2px',
    textAlign: 'center',
    color: '#2c3e50'
  };

  const descStyle = {
    color: '#666',
    textAlign: 'center',
    margin: '0',
    lineHeight: '1.6'
  };

  return (
    <div 
      className="icon-box" 
      style={cardStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="icon" style={iconStyle}>
        {icon}
      </div>
      <h4 className="title" style={titleStyle}>
        <Link to="">{title}</Link>
      </h4>
      <p className="description" style={descStyle}>
        {children}
      </p>
    </div>
  );
};

// CardContainer component is no longer needed as we're using inline styles

function Home() {
  const { userLocation, userCurrency } = useGeoLocation();
  
  const gotoTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  function createData(feature, clubhosty, godaddy, hostinger, bluehost, hostgator, milesweb, dreamhost) {
    return { feature, clubhosty, godaddy, hostinger, bluehost, hostgator, milesweb, dreamhost };
  }

  const rows = [
    createData(
      "Starting From ",
      "₹ 79/mo",
      "₹ 149/mo",
      "₹ 399/mo",
      "₹ 279/mo",
      "₹ 299/mo",
      "₹ 300/mo",
      "₹ 399/mo"
    ),
    createData(
      "NvMe SSD Storage",
      <FaCheckCircle key="nvme-1" />,
      <FaCheckCircle key="nvme-2" />,
      <ImCross key="nvme-3" />,
      <ImCross key="nvme-4" />,
      <ImCross key="nvme-5" />,
      <FaCheckCircle key="nvme-6" />,
      <ImCross key="nvme-7" />
    ),
    createData(
      "Free Unlimited SSL",
      <FaCheckCircle key="ssl-1" />,
      <ImCross key="ssl-2" />,
      <FaCheckCircle key="ssl-3" />,
      <FaCheckCircle key="ssl-4" />,
      <FaCheckCircle key="ssl-5" />,
      <FaCheckCircle key="ssl-6" />,
      <FaCheckCircle key="ssl-7" />
    ),
    createData(
      "Cloudflare CDN Cache",
      <FaCheckCircle key="cdn-1" />,
      <ImCross key="cdn-2" />,
      <ImCross key="cdn-3" />,
      <ImCross key="cdn-4" />,
      <ImCross key="cdn-5" />,
      <FaCheckCircle key="cdn-6" />,
      <ImCross key="cdn-7" />
    ),
    createData(
      "Imunify360 AntiMalware",
      <FaCheckCircle key="imunify-1" />,
      <ImCross key="imunify-2" />,
      <ImCross key="imunify-3" />,
      <FaCheckCircle key="imunify-4" />,
      <FaCheckCircle key="imunify-5" />,
      <FaCheckCircle key="imunify-6" />,
      <FaCheckCircle key="imunify-7" />
    ),
    createData(
      "DDoS & Firewall",
      <FaCheckCircle key="ddos-1" />,
      <ImCross key="ddos-2" />,
      <FaCheckCircle key="ddos-3" />,
      <ImCross key="ddos-4" />,
      <ImCross key="ddos-5" />,
      <FaCheckCircle key="ddos-6" />,
      <ImCross key="ddos-7" />
    ),
    createData(
      "Free Daily Backups",
      <FaCheckCircle key="backup-1" />,
      <ImCross key="backup-2" />,
      <ImCross key="backup-3" />,
      <ImCross key="backup-4" />,
      <ImCross key="backup-5" />,
      <ImCross key="backup-6" />,
      <ImCross key="backup-7" />
    ),
    createData(
      "Multiple Server Location",
      <FaCheckCircle key="location-1" />,
      <ImCross key="location-2" />,
      <FaCheckCircle key="location-3" />,
      <ImCross key="location-4" />,
      <ImCross key="location-5" />,
      <ImCross key="location-6" />,
      <ImCross key="location-7" />
    )
  ];

  // Enhanced SEO configuration
  const homePageConfig = generateMetaTags(pageConfigs.home);
  
  // Structured data for home page
  const homeStructuredData = [
    organizationSchema,
    generateServiceSchema(
      "Web Hosting Services",
      "Comprehensive web hosting solutions including shared hosting, VPS hosting, cloud hosting, and domain registration services in India."
    ),
    generateFAQSchema([
      {
        question: "What makes ClubHosty the best web hosting provider in India?",
        answer: "ClubHosty offers affordable web hosting plans with 99.9% uptime guarantee, free SSL certificates, 24/7 customer support, and state-of-the-art data centers in India."
      },
      {
        question: "Do you provide free domain registration?",
        answer: "Yes, we provide free domain registration with our annual hosting plans. You can choose from various domain extensions."
      },
      {
        question: "Is there a money-back guarantee?",
        answer: "Yes, we offer a 30-day money-back guarantee on all our hosting plans. If you're not satisfied, you can get a full refund within 30 days."
      }
    ])
  ];

  return (
    <>
      <EnhancedSEO 
        pageConfig={homePageConfig}
        structuredData={homeStructuredData}
      />
      {/* ======= Hero Section ======= */}
      <Herosec />

      <main id="main">
        {/* ======= Pricing Section =======  */}
        <section id="pricing" className="pricing section-bg">
          <div className="container">
            <div className="section-title">
              <h2>Pricing</h2>
              <h1 className="h1">
                Choose Your Best Affordable Web Hosting Plan
              </h1>
            </div>

            {/* Location-based pricing info */}
            {userLocation && (
              <div style={{
                backgroundColor: '#e6f9fa',
                padding: '12px 20px',
                borderRadius: '8px',
                marginBottom: '30px',
                border: '1px solid #b3ecef',
                textAlign: 'center'
              }}>
                <p style={{ 
                  margin: 0, 
                  color: '#21a2a0', 
                  fontWeight: '500',
                  fontSize: '14px'
                }}>
                  📍 Showing prices for {userLocation.country} 
                  {userCurrency !== 'INR' && ` in ${userCurrency}`}
                </p>
              </div>
            )}

            <div className="row">
              <div className="col-md-4" data-aos-delay="100">
                <div className="box">
                  <div className="pricing-head">
                    <p>Shared Hosting</p>
                    <p className="subprichead">
                      Best plan to kick-start your online journey
                    </p>
                  </div>
                  <h4>
                    <sup>₹</sup>79<span> / month</span>
                    {userLocation && userCurrency !== 'INR' && (
                      <div style={{ fontSize: '0.8em', color: '#666', marginTop: '5px' }}>
                        <CurrencyConverter priceINR={79} size="small" />
                      </div>
                    )}
                  </h4>
                  <ul>
                    <li>Host 1 Website</li>
                    <li>10 GB Disk Space</li>
                    <li>2 Email Accounts</li>
                    <li>Free SSL Certificate</li>
                    <li>Unlimited Bandwidth</li>
                  </ul>
                  <div className="btn-wrap">
                    <Link
                      to="/sharedHosting"
                      className="btn-buy"
                      onClick={gotoTop}
                    >
                      See More
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-md-4" data-aos-delay="100">
                <div className="box">
                  <div className="pricing-head">
                    <p>Reseller Hosting</p>
                    <p className="subprichead">
                      Best plan if you're on a mission to become a reseller!
                    </p>
                  </div>
                  <h4>
                    <sup>₹</sup>599<span> / month</span>
                    {userLocation && userCurrency !== 'INR' && (
                      <div style={{ fontSize: '0.8em', color: '#666', marginTop: '5px' }}>
                        <CurrencyConverter priceINR={599} size="small" />
                      </div>
                    )}
                  </h4>
                  <ul>
                    <li>50 Cpanel</li>
                    <li>100 GB Disk Space</li>
                    <li>Free SSL Certificate</li>
                    <li>Unlimited Bandwidth</li>
                    <li>Unlimited Email Accounts</li>
                  </ul>
                  <div className="btn-wrap">
                    <Link to="/affordable-reseller-web-hosting" className="btn-buy" onClick={gotoTop}>
                      See More
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-md-4" data-aos-delay="100">
                <div className="box">
                  <div className="pricing-head">
                    <p>VPS Server</p>
                    <p className="subprichead">
                      Best plan to take your online journey to next level!
                    </p>
                  </div>
                  <h4>
                    <sup>₹</sup>459<span> / month</span>
                    {userLocation && userCurrency !== 'INR' && (
                      <div style={{ fontSize: '0.8em', color: '#666', marginTop: '5px' }}>
                        <CurrencyConverter priceINR={459} size="small" />
                      </div>
                    )}
                  </h4>
                  <ul>
                    <li>2 vCPU</li>
                    <li>4 GB RAM</li>
                    <li>20TB Bandwidth</li>
                    <li>50 GB Disk Space</li>
                    <li>1 GB/s internet Port</li>
                  </ul>
                  <div className="btn-wrap">
                    <Link to="/affordable-linux-vps-hosting" className="btn-buy" onClick={gotoTop}>
                      See More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="pricing" className="pricing ">
          <div className="container">
            <div className="section-title">
              <h2>Pricing</h2>
              <h3>Compare us with any of your favourite service</h3>
            </div>

            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell></StyledTableCell>
                    <StyledTableCell align="right">
                      <img src="/assets/img/logo.webp" alt="ClubHosty Logo" />
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      <img src="./assets/img/godaddy.png" alt="GoDaddy Logo" />
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      <img src="./assets/img/hostinger.png" alt="Hostinger Logo" />
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      <img src="./assets/img/bluehost.png" alt="Bluehost Logo" />
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      <img src="./assets/img/hostgator.png" alt="HostGator Logo" />
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      <img src="./assets/img/milesweb.png" alt="MilesWeb Logo" />
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      <img src="./assets/img/dreamhost.png" alt="DreamHost Logo" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <StyledTableRow key={row.feature}>
                      <StyledTableCell component="th" scope="row">
                        {row.feature}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.clubhosty}
                      </StyledTableCell>
                      <StyledTableCell align="right">{row.godaddy}</StyledTableCell>
                      <StyledTableCell align="right">
                        {row.hostinger}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.bluehost}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.hostgator}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.milesweb}
                      </StyledTableCell>
                      <StyledTableCell align="right">{row.dreamhost}</StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </section>
        {/* End Pricing Section  */}
        {/* <HomeComp/> */}

        {/* ======= Featured Services Section ======= */}
        <section
          id="featured-services"
          className="featured-services section-bg"
          style={{ padding: '60px 0' }}
        >
          <div className="container">
            <div className="section-title" style={{ textAlign: 'center', marginBottom: '4px' }}>
              <h2>Why Choose ClubHosty?</h2>
              <p><strong>Everything you need to create your website</strong></p>
              <p style={{ textAlign: 'center' }}>Get all the essential tools and features to build and grow your website with our comprehensive hosting solutions</p>
            </div>
            <div className="row g-4">
              <div className="col-lg-4 col-md-6">
                <FeatureCard 
                  icon={<FaServer />} 
                  title="LiteSpeed Server"
                >
                  LiteSpeed Server is a high-performance web server software
                  designed for better performance and scalability.
                </FeatureCard>
              </div>

              <div className="col-lg-4 col-md-6">
                <FeatureCard 
                  icon={<FaHandPointer />} 
                  title="1 Click Installer"
                >
                  Softaculous is a one-click installer that automates the
                  installation of web applications.
                </FeatureCard>
              </div>

              <div className="col-lg-4 col-md-6">
                <FeatureCard 
                  icon={<FaSync />} 
                  title="Free Daily Backup"
                >
                  Free Daily backup is a process of backing up data on a
                  Daily basis without any additional cost.
                </FeatureCard>
              </div>

              <div className="col-lg-4 col-md-6">
                <FeatureCard 
                  icon={<FaDesktop />} 
                  title="Control Panel"
                >
                  ClubHosty provides you with Direct Admin and Cpanel to
                  manage your hosting account easily.
                </FeatureCard>
              </div>

              <div className="col-lg-4 col-md-6">
                <FeatureCard 
                  icon={<FaHdd />} 
                  title="NVME SSD Storage"
                >
                  NVME SSD(s) are 20X faster than a normal HDD & helps make
                  sure much more fast!
                </FeatureCard>
              </div>

              <div className="col-lg-4 col-md-6">
                <FeatureCard 
                  icon={<FaLock />} 
                  title="Free SSL Certificate"
                >
                  All of our web hosting plans come with a free SSL
                  Certificate by Let's Encrypt to make sure your site is
                  secure.
                </FeatureCard>
              </div>
            </div>
          </div>
        </section>
        {/* End Featured Services Section  */}
        {/* ======= About Section ======= */}
        <section id="about" className="about ">
          <div className="container">
            <div className="row">
              <div
                className="col-lg-6 pt-4 pt-lg-0 content d-flex flex-column justify-content-center"
                data-aos-delay="100"
              >
                <h3>
                  Get Your Website Online In <span>Three Easy Steps</span>
                </h3>
                <p className="fst-italic">
                  We've got everything from domain names to Affordable Web
                  Hosting ! Get your business online today!
                </p>
              </div>
              <div className="col-lg-6 content" data-aos-delay="100">
                <ul>
                  <li>
                    <i className="bx bxs-server"></i>
                    <div>
                      <h5>Step 1: Choose a Web Hosting plan.</h5>
                      <p>
                        Select a web hosting plan suitable for your business.
                        Need help? Get in touch with our hosting experts at +91
                        70503 89077
                      </p>
                    </div>
                  </li>
                  <li>
                    <i className="bx bx-world"></i>
                    <div>
                      <h5>Step 2: Select or buy a Domain name.</h5>
                      <p>
                        Select a Domain name or if you don't have a Domain, you
                        can register along with a Web Hosting plan.
                      </p>
                    </div>
                  </li>
                  <li>
                    <i className="bx bxs-cloud-upload"></i>
                    <div>
                      <h5>Step 3: Upload your website.</h5>
                      <p>
                        Upload your website files to the directory or, create a
                        new website using a CMS like WordPress.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* End About Section  */}

        {/* ======= Services Section ======= */}
        <section id="services" className="services section-bg">
          <div className="container">
            <div className="section-title">
              <h2>Services</h2>
              <h3>
                Why choose <span>ClubHosty</span> for your projects?
              </h3>
              <p>
                ClubHosty marketplace gives you access to hundreds of free and
                premium website solutions. Pick one that suits you and start
                building.
              </p>
            </div>

            <div className="row">
              <div className="col-md-6" data-aos-delay="100">
                <div className="icon-box">
                  <div className="icon">
                    <i className="fa fa-shield"></i>
                  </div>
                  <h4>
                    <Link to="">Fast & Secure</Link>
                  </h4>
                  <p>
                    Provides fast website loading times and strong security
                    measures, such as SSL certificates, firewalls, and malware
                    protection, ensuring a positive user experience and
                    protecting against cyber threats.
                  </p>
                </div>
              </div>

              <div className="col-md-6" data-aos-delay="200">
                <div className="icon-box">
                  <div className="icon">
                    <i className="bx bx-support"></i>
                  </div>
                  <h4>
                    <Link to="">24/7 Support</Link>
                  </h4>
                  <p>
                    Available 24 hours a day, 7 days a week. It is designed to
                    provide customers with assistance, troubleshooting, and
                    technical support at any time, ensuring prompt resolution of
                    issues and a positive user experience.
                  </p>
                </div>
              </div>

              <div className="col-md-6" data-aos-delay="300">
                <div className="icon-box">
                  <div className="icon">
                    <i className="bx bx-tachometer"></i>
                  </div>
                  <h4>
                    <Link to="">Money-back Guarantee</Link>
                  </h4>
                  <p>
                    Try us and you'll love us. If not, get a refund within 7
                    days of signing up. Your satisfaction is our top priority.
                  </p>
                </div>
              </div>

              <div className="col-md-6" data-aos-delay="100">
                <div className="icon-box">
                  <div className="icon">
                    <i className="bx bx-world"></i>
                  </div>
                  <h4>
                    <Link to="">99.9% Uptime</Link>
                  </h4>
                  <p>
                    We understand your website is vital for your business. All
                    our web hosting plans come with a promise of 99.9% uptime.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section appbgsection gray-bg  padding">
          <div className="container">
            <div className="row md-p-25px-tb">
              <div className="col-lg-6 mx-auto text-center">
                <h2 className="rt-section-title demo">
                  <span>Apps With 1 Click Install</span>
                </h2>
                <p>
                  You’ll be able to easily install 422+ of apps including
                  WordPress, Joomla, and Drupal with just 1-click.
                </p>
              </div>
            </div>
            <div className="col-12">
              <ul className="rt-list install-list-item">
                <li>
                  <img src="../assets/apps/09.png" alt="9" />
                </li>
                <li>
                  <img src="../assets/apps/02.png" alt="2" />
                </li>
                <li>
                  <img src="../assets/apps/03.png" alt="3" />
                </li>
                <li>
                  <img src="../assets/apps/04.png" alt="4" />
                </li>
                <li>
                  <img src="../assets/apps/05.png" alt="5" />
                </li>
                <li>
                  <img src="../assets/apps/06.png" alt="6" />
                </li>
                <li>
                  <img src="../assets/apps/07.png" alt="7" />
                </li>
                <li>
                  <img src="../assets/apps/08.png" alt="8" />
                </li>
                <li>
                  <img src="../assets/apps/01.png" alt="1" />
                </li>
                <li>
                  <img src="../assets/apps/10.png" alt="10" />
                </li>
                <li>
                  <img src="../assets/apps/11.png" alt="11" />
                </li>
                <li>
                  <img src="../assets/apps/12.png" alt="12" />
                </li>
                <li>
                  <img src="../assets/apps/13.png" alt="13" />
                </li>
                <li>
                  <img src="../assets/apps/14.png" alt="14" />
                </li>
                <li>
                  <img src="../assets/apps/15.png" alt="15" />
                </li>
                <li>
                  <img src="../assets/apps/16.png" alt="16" />
                </li>
                <li>
                  <img src="../assets/apps/17.png" alt="17" />
                </li>
                <li>
                  <img src="../assets/apps/18.png" alt="18" />
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* End Services Section  */}

        {/* Start FAQ Section  */}

        <section id="about" className="about ">
          <div className="section-title">
            <h2>Frequently Asked Questions</h2>

            {/* <p style={{ padding: "10px" }}>
						You ask, we answer! Here are the most asked questions for our Domain
						Registration service!
					</p> */}
            <Divider />
          </div>
          <div className="accordionContainer">
            <Accordion allowZeroExpanded>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Where ClubHosty is located?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Despite ClubHosty providing its high-quality web hosting
                    services to all across the globe.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Why choose ClubHosty hosting services?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    ClubHosty is especially popular for providing high-quality
                    web hosting services and blazing-fast performance at very
                    affordable rates. Hence if you want both quality and
                    affordability then ClubHosty will be a suitable pick for
                    you!!
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What features are offered in ClubHosty web hosting Plan?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    One of the best aspects of ClubHosty is that we host your
                    website on servers equipped with the latest and the most
                    advanced hardware equipment, making your website blazing
                    fast on the internet.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Can I upgrade my web hosting plan Later?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes, Our servers are resilient enough to allow you anytime
                    upgradation of your resources, so no matter whether you are
                    planning to start a new business or you want to scale your
                    business you can upgrade to any plan without any hidden
                    charges.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Can I host a business website with ClubHosty hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes, ClubHosty provides unmetered resources with their
                    services which means you can use your allocated resources
                    without any restriction or additional charges. Hence you can
                    also host high-traffic business websites very smoothly.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Will you help me to migrate my website from another host to
                    ClubHosty?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes, ClubHosty provides completely free website
                    migration(upto 5GB*) to their quality servers. So if you are
                    stuck with a low-quality service provider, you can shift to
                    a better choice.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Does ClubHosty’s Hosting Plans Suitable For Someone With No
                    Technical Knowledge?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes, We provide fully managed web hosting services so that
                    you can easily manage and maintain your website even though
                    you have no prior technical knowledge.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Do I have to buy a domain name with a web hosting plan?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    No, ClubHosty has bundled free of cost domains with annual
                    plans so that you can easily avail of their services even
                    though you have a low budget!!
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Do you offer a money-back Guaranteed?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes, We assure you a full refund if you are not satisfied
                    with our services which allows you to cancel the service
                    anytime within 7 days and get your full money back.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </section>

        {/* End FAQ Section  */}
      </main>
    </>
  );
}

export default Home;
